import * as o from "react";
import t from "../lib/IconBase.es.js";
import c from "../defs/ArrowsCounterClockwise.es.js";
const r = o.forwardRef((e, s) => /* @__PURE__ */ o.createElement(t, { ref: s, ...e, weights: c }));
r.displayName = "ArrowsCounterClockwiseIcon";
const i = r;
export {
  i as ArrowsCounterClockwise,
  r as ArrowsCounterClockwiseIcon
};
